/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type JobEventScheduled_event$ref: FragmentReference;
export type JobEventScheduled_event = {|
  +timestamp: any,
  +$refType: JobEventScheduled_event$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "JobEventScheduled_event",
  "type": "JobEvent",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "timestamp",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'c49f7ec9f9506d59cbc625e1e47476fa';
module.exports = node;
